import {useContext, useEffect, useState} from "react";
import {getWindowSize} from "./windowSize";
import {devAlert} from "../Utility/logging";
import {isEmpty} from "lodash";

/**
 * HOOK: useWindowSize()
 *
 * @returns {[number,number]}
 */
export function useWindowSize() {
  const [dimensions, setDimensions] = useState(getWindowSize());

  useEffect(() => {
    if (!globalThis.window) return;

    const handleResize = () => {
      let d = getWindowSize();
      //console.log(`RESIZE: to ${d}`);
      setDimensions(d);
    };

    // console.log("add resizeListener");
    window.addEventListener('resize', handleResize);

    return (() => {
      // console.log("remove resizeListener");
      window.removeEventListener('resize', handleResize);
    })
  }, []);

  return dimensions;
}

/**
 * A whinier version of useContext().
 *
 * @param contextClass
 * @returns {*}
 */
export function useNonEmptyContext(contextClass) {
  let value = useContext(contextClass);

  if (isEmpty(value)) {
    let msg = "useNonEmptyContext: context " + contextClass + " is empty!";
    devAlert(msg);
    console.error(msg);
  }
  return value;
}
